import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import MemberCard from "./MemberCard";
import members, { memberGroups } from "../../data/members";

function Team() {
    return (
        <section>
            <Container fluid className="project-section">
                <h1 className="white-text">Team Members</h1>
            </Container>
            {memberGroups.map((group) => {
                const groupMembers = members.filter((member) => member.showOnTeam && member.group === group.id);
                if (groupMembers.length === 0) return null;
                return (
                    <Container key={group.id} style={{ textAlign: "left" }} className="home-research-section">
                        <h2>{group.label}</h2>
                        <Container>
                            <Row>
                                {groupMembers.map((member) => (
                                    <Col key={member.id} md={4} className="project-card">
                                        <MemberCard member={member} />
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    </Container>
                );
            })}
        </section>
    );
}

export default Team;
